import { type FC } from 'react';
import fileSaver from 'file-saver';
import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Button, DropdownList, Icons } from '@/js/libs/ui/src/V2';
import { PrivateContent, Roles } from '@/js/libs/use-auth';

import { ROUTER } from 'src/AppRouter.tsx';
import { DEV_MODE, EXTERNAL_API_SPEC_FILE_NAME, EXTERNAL_API_SPEC_URL, SUPPORT_EMAIL } from 'src/constants.tsx';

export const SupportButton: FC = () => {
  const [t] = useTranslation(['apiDocumentation', 'common', 'components', 'supportChat']);

  const mailToSupport = useCallbackRef(() => {
    window.location.href = `mailto:${SUPPORT_EMAIL}`;
  });

  const openUsersnap = useCallbackRef(() => {
    window.Usersnap?.logEvent('open_usersnap');
  });

  const downloadApiSpec = useCallbackRef(() => {
    fileSaver.saveAs(EXTERNAL_API_SPEC_URL, EXTERNAL_API_SPEC_FILE_NAME);
  });

  return (
    <DropdownList
      minWidth={false}
      dataTestId='support-button'
      renderButton={() => (
        <Button iconOnly ghost title={t('common:SUPPORT')}>
          <Icons.Headphones size={20} />
        </Button>
      )}>
      {DEV_MODE && (
        <PrivateContent roles={Roles.SUPPORT_CENTER}>
          <DropdownList.DropdownItem icon={<Icons.Draft />} to={ROUTER['/support-center/tickets'].path.pattern} dataTestId='tickets-button'>
            {t('components:TICKETS')}
          </DropdownList.DropdownItem>
        </PrivateContent>
      )}
      {DEV_MODE && (
        <DropdownList.DropdownItem
          icon={<Icons.AiChat />}
          to={ROUTER['/support-chat/:convId'].path({ convId: 'new' })}
          dataTestId='support-chat-button'>
          {t('supportChat:TITLE')}
        </DropdownList.DropdownItem>
      )}
      {DEV_MODE && (
        <DropdownList.DropdownItem icon={<Icons.Download />} onClick={downloadApiSpec} dataTestId='api-documentation-button'>
          {t('apiDocumentation:API_DOCUMENTATION')}
        </DropdownList.DropdownItem>
      )}
      <DropdownList.DropdownItem icon={<Icons.Mail />} onClick={mailToSupport} dataTestId='contact-us-button' tooltip={SUPPORT_EMAIL}>
        {t('common:CONTACT_US')}
      </DropdownList.DropdownItem>
      <DropdownList.DropdownItem icon={<Icons.MouseCursor />} onClick={openUsersnap} dataTestId='usersnap-button'>
        {t('common:USERSNAP')}
      </DropdownList.DropdownItem>
    </DropdownList>
  );
};
